import React from 'react';
import { FormControl, FormControlLabel, Input, InputAdornment, InputLabel } from '@mui/material';

import Checkbox from '../Checkbox/Checkbox';
import { CHARGER_TASK_TYPE_LABEL_VALUE_LIST } from '../../constants/chargerTask';
import { makeMenuItems } from '../Helper/helper';
import Select from '../Select/Select';
import TextField from '../TextField/TextField';
import FormSectionSeparator from '../FormSectionSeparator/FormSectionSeparator';
import { FormWrap, FormColumn, CheckboxWrap, ModeDescription, Error } from './style';
import DiagnosticCategoriesControl from './DiagnosticCategoriesControl';
import { DateTimePicker } from '../DateTimePickers/DateTimePickers';

function ChargerTaskForm(props) {
  const { chargerId, defaultState, currentState, onChange, error } = props;
  const { simple } = currentState;

  const handleDatePickerChanges = (name) => (value) => {
    onChange({ target: { value, name } });
  };

  return (
    <FormWrap>
      <FormColumn>
        <FormControl fullWidth>
          <InputLabel>Task type</InputLabel>
          <Select defaultValue={defaultState.type}>{makeMenuItems(CHARGER_TASK_TYPE_LABEL_VALUE_LIST)}</Select>
        </FormControl>
      </FormColumn>

      <FormColumn>
        {/* <FormControl fullWidth>
            <InputLabel shrink>Notification</InputLabel>
            <CheckboxWrap>
              <FormControlLabel
                control={
                  <Checkbox
                    name="enableNotifications"
                    defaultChecked={defaultState.enableNotifications}
                    onChange={onChange}
                    color="primary"
                  />
                }
                label="Notify by email if completed"
              />
            </CheckboxWrap>
              </FormControl> */}
      </FormColumn>

      <FormSectionSeparator>Diagnostic Parameters</FormSectionSeparator>

      <FormColumn>
        <DateTimePicker
          inputVariant="standard"
          value={currentState.collectFromTimestamp}
          onAccept={handleDatePickerChanges('collectFromTimestamp')}
          label="Logs time (UTC) from"
          format="MMMM D, YYYY hh:mm A"
        />
      </FormColumn>

      <FormColumn>
        <DateTimePicker
          inputVariant="standard"
          value={currentState.collectToTimestamp}
          onAccept={handleDatePickerChanges('collectToTimestamp')}
          label="Logs time (UTC) to"
          format="MMMM D, YYYY hh:mm A"
        />
      </FormColumn>

      <FormColumn className="full-width">
        <TextField
          multiline
          label="Notes"
          name="note"
          defaultValue={defaultState.note}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
        />
      </FormColumn>

      <FormSectionSeparator onChange={onChange} defaultValue={defaultState.simple} name="simple" oppositeLabel="Use simple mode">
        Use extended mode
      </FormSectionSeparator>

      {simple && (
        <ModeDescription>
          Simple mode is using the default “Get Diagnostics” task parameters. In order to extend categories or to more parameters please
          click the “USE EXTENDED MODE” label above.
        </ModeDescription>
      )}

      <>
        <FormColumn
          style={{
            display: simple ? 'none' : 'flex',
          }}
        >
          <FormControl fullWidth>
            <InputLabel shrink>Not related to Time Range</InputLabel>
            <CheckboxWrap>
              <FormControlLabel
                control={<Checkbox color="primary" name="pcapFiles" onChange={onChange} defaultChecked={defaultState.pcapFiles} />}
                label="Pcap files"
              />
            </CheckboxWrap>
          </FormControl>
          <DiagnosticCategoriesControl
            name="diagnostics"
            onChange={onChange}
            chargerId={chargerId}
            defaultValue={defaultState.diagnostics}
            label="Diagnostic categories"
          />
        </FormColumn>

        <FormColumn
          style={{
            display: simple ? 'none' : 'flex',
          }}
        >
          <FormControl fullWidth>
            <InputLabel shrink>Included</InputLabel>
            <CheckboxWrap>
              <FormControlLabel
                control={<Checkbox color="primary" name="configs" onChange={onChange} defaultChecked={defaultState.configs} />}
                label="Configs"
              />
              <FormControlLabel
                control={<Checkbox color="primary" name="systemInfo" onChange={onChange} defaultChecked={defaultState.systemInfo} />}
                label="System info"
              />
            </CheckboxWrap>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel shrink>Upload to cloud</InputLabel>
            <CheckboxWrap>
              <FormControlLabel
                control={<Checkbox color="primary" name="autoUpload" defaultChecked={defaultState.autoUpload} onChange={onChange} />}
                label="Automatically"
              />
            </CheckboxWrap>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel shrink>Max file size</InputLabel>
            <Input
              type="number"
              inputProps={{ min: 1 }}
              disabled={!currentState.autoUpload}
              style={{ width: '100px' }}
              defaultValue={defaultState.autoUploadSizeLimit}
              name="autoUploadSizeLimit"
              onChange={onChange}
              endAdornment={<InputAdornment position="end">Mb</InputAdornment>}
            />
          </FormControl>
        </FormColumn>
      </>

      {error && <Error>{error}</Error>}
    </FormWrap>
  );
}

export default ChargerTaskForm;
